// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PI2e1kFKzx3KleFFM1Ro,.hvQEV3CTl6BdWKI5G8Fh{width:109px}`, "",{"version":3,"sources":["webpack://./src/pages/clickToText/pages/all/ui/EmptyStateClickToText/styles.module.scss"],"names":[],"mappings":"AAAA,4CAEE,WAAA","sourcesContent":[".helpGuideButton,\n.newLinkButton {\n  width: 109px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpGuideButton": `PI2e1kFKzx3KleFFM1Ro`,
	"newLinkButton": `hvQEV3CTl6BdWKI5G8Fh`
};
export default ___CSS_LOADER_EXPORT___;
